// Package imports:
import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Style imports:
// import './AvailableReports.scss';
// Component imports:
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
// Service imports:
// Action imports:
// Type imports:
import { RootState } from '../../redux-store/reducers';
import { isUserLoggedIn } from '../../services/loginUtils';

type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps;

const AvailableReports: React.FC<Props> = ({ hasEmsToken }) => {
    useEffect(() => {
        document.title = 'Reports | KODIAK Sigti';
    }, []);

    const displayRows = () => {
        const ALL_REPORTS = [{
            name: 'Cancelled standard trades',
            description: 'Cancelled standard trades for a given date range',
            report_id: 1,
            private: true
        }, {
            name: 'Broken trade reports',
            description: 'Broken trade reports for a given date range',
            report_id: 2,
            private: true
        }, {
            name: 'Alert Summary',
            description: 'Alert summary showing count of alerts and status for a given date range',
            report_id: 3,
            private: false
        }, {
            name: 'Alert Summary per trader ID',
            description: 'Alert summary showing count of alerts per trader for a given date range',
            report_id: 4,
            private: false
        },
        {
            name: 'Alert Summary per Client ID',
            description: 'Alert summary showing count of alerts per client for a given date range',
            report_id: 5,
            private: false
        }];

        const availableReports = ALL_REPORTS.filter(report => (
            !report.private
            || (
                report.private
                && hasEmsToken
            )
        ));

        const availableReportsJsx = availableReports.map(report => (
            <tr
                key={report.report_id}
                onClick={() => {
                    window.location.href = window.location.origin + `/report/${report.report_id}`;
                }}
            >
                <td className='text-left'>{report.name}</td>
                <td className='text-left'>{report.description}</td>
            </tr>
        ));

        if (availableReportsJsx.length === 0) {
            return (
                <tr className='NoClick'>
                    <td className='text-left' colSpan={2}>
                        No Reports
                    </td>
                </tr>
            )
        }

        return availableReportsJsx;
    }

    return (
        <Container id='AvailableReports' fluid>
            <Row>
                <Col xs={12}>
                    <h5 className='SectionTitle'>Available Reports</h5>
                    <Table id='ReportsTable' className='CompressedTable ClickableRows'>
                        <thead>
                            <tr>
                                <th scope='col' className='text-left'>Name</th>
                                <th scope='col' className='text-left'>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayRows()}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Container>
    );
}

function mapStateToProps({ loginReducer }: RootState) {
    const { hasEmsToken } = isUserLoggedIn(loginReducer)
    return {
        hasEmsToken
    };
}

const connector = connect(mapStateToProps);
export default connector(AvailableReports);

